import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog, DialogContent, DialogTitle, Divider, IconButton } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { useAppSelector } from "hooks/store";
import { Typography } from "new-components/typography/Typography";

const mapDescriptionText = {
  detector:
    "You have reached the maximum amount of Active Detectors for your plan. <br /> Please upgrade your plan or disable existing detectors to continue using it.",
  "image-query":
    "You have reached the maximum amount of Image Queries for your plan. <br /> Please upgrade your plan to continue using it.",
};

export interface UserLimitModalProps {
  type: "image-query" | "detector";
  isModalOpen: boolean;
  handleCloseModal: () => void;
}

export function UserLimitModal(props: UserLimitModalProps) {
  const { type, isModalOpen, handleCloseModal } = props;

  const { data: dataLimit } = useAppSelector((state) => state.dataLimit);

  const { data: userLimitData } = useAppSelector((state) => state.userLimit);

  const shouldCloseModal =
    !userLimitData.iqIsBlocked && !userLimitData.escalationIsBlocked && !userLimitData.detectorIsBlocked;

  const handleCloseLimit = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleCloseModal();
  };

  useEffect(() => {
    if (shouldCloseModal) handleCloseModal();
  }, [shouldCloseModal, handleCloseModal]);

  return (
    <Dialog
      open={isModalOpen}
      onClose={handleCloseLimit}
      fullWidth
      maxWidth="md"
      PaperProps={{ onClick: (e: React.MouseEvent) => e.stopPropagation() }}
    >
      <DialogTitle id="scroll-dialog-title" className="flex justify-between items-center bg-[#0450BA] p-4">
        <Box />
        <Typography textTransform="uppercase" className="text-white">
          Plan Limit
        </Typography>
        <IconButton onClick={handleCloseModal}>
          <CloseIcon className="text-white" />
        </IconButton>
      </DialogTitle>
      <DialogContent className="p-6">
        <Box className="flex justify-center mb-4">
          <Typography variant="subtitle" align="center" dangerouslySetInnerHTML={{ __html: mapDescriptionText[type] }} />
        </Box>

        <Box className="flex justify-center mb-4">
          <Box className="flex gap-2">
            {type === "detector" ? (
              <>
                <Typography>
                  Active Detector Limit: {dataLimit?.active_detectors_limit || "0"}
                </Typography>
                <Typography className="text-[#FF3399]">
                  ({dataLimit.active_detectors || "0"} Active Detectors)
                </Typography>
              </>
            ) : (
              <>
                <Typography>Included Image Queries: {dataLimit?.iqs_limit || "0"}</Typography>
                <Typography className="text-[#FF3399]">
                  ({dataLimit.iqs || "0"} used this month, service paused)
                </Typography>
              </>
            )}
          </Box>
        </Box>

        <Divider className="mx-56 my-4" />

        <Box className="flex flex-col sm:flex-row justify-center gap-4">
          <Button
            className="bg-white text-xl text-[#214FB3] w-full sm:w-[280px]"
            variant="outlined"
            onClick={handleCloseModal}
          >
            Ok
          </Button>
          <Link to="/reef/my-account">
            <Button className="text-white text-xl bg-[#214FB3] sm:w-[280px]" variant="outlined">
              Upgrade Service Plan
            </Button>
          </Link>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
